import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';
import Flex from '../Flex';

var AppBar = function AppBar(_ref) {
  var leftContent = _ref.leftContent,
      middleContent = _ref.middleContent,
      rightContent = _ref.rightContent,
      bottomContent = _ref.bottomContent,
      contentMaxWidth = _ref.contentMaxWidth,
      restProps = _objectWithoutProperties(_ref, ["leftContent", "middleContent", "rightContent", "bottomContent", "contentMaxWidth"]);

  return React.createElement(Flex, _extends({
    as: "header",
    flexDirection: "column"
  }, restProps, {
    "data-testid": "app-bar"
  }), React.createElement(Flex, {
    flexWrap: "wrap",
    mx: "auto",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 72,
    width: "100%",
    maxWidth: contentMaxWidth
  }, leftContent && React.createElement(Flex, {
    alignItems: "center",
    flex: 1,
    fontWeight: "bold"
  }, leftContent), middleContent && React.createElement(Flex, {
    height: "100%",
    justifyContent: "center",
    flex: 1,
    alignItems: "center"
  }, middleContent), rightContent && React.createElement(Flex, {
    flex: 1,
    justifyContent: "flex-end"
  }, rightContent)), bottomContent && React.createElement(Box, {
    flex: "1 0 100%",
    width: "100%",
    pb: 2
  }, bottomContent));
};

AppBar.defaultProps = {
  leftContent: null,
  middleContent: null,
  rightContent: null,
  bottomContent: null,
  contentMaxWidth: null,
  bg: 'background',
  px: 2,
  boxShadow: 100
};
export default AppBar;